import { render } from "./certificat-travail-valid.vue?vue&type=template&id=6a145b09"
import script from "./certificat-travail-valid.vue?vue&type=script&lang=js"
export * from "./certificat-travail-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__